export const MIXPANEL_DEBOUNCE_TIME = 500;

export enum EMixpanelProperties {
  ACCOUNT_BALANCE = 'Account Balance',
  ACCOUNT_NAME = 'Account Name',
  ASK = 'Ask',
  BASE_CURRENCY = 'Account Currency',
  BID = 'Bid',
  FILL_POLICY = 'Fill Policy',
  INDICATE = 'Indicate',
  IS_DEMO = 'Is Demo',
  LEVERAGE = 'Leverage',
  LOT_SIZE = 'Full Volume / Size', // Max volume / size for a symbol
  VOLUME_SIZE_SUBMITTED = 'Volume / Size Submitted', // max order size when close order
  MAIN_PRODUCT_CODE = 'Main Product Code',
  MARKET_SUBSCRIPTION = 'Market Subscription',
  METATRADER_GROUP = 'Metatrader Group',
  METATRADER_ID = 'Metatrader Id',
  NAME = '$name', // Mixpanel reserve property
  ORDER_TYPE = 'Order Type',
  PENDING_PRICE = 'Stop Limit Price',
  PLATFORM = 'Platform',
  SOURCE = 'Source',
  STOP_LOSS = 'Stop Loss',
  SYMBOL = 'Symbol',
  SYMBOL_CURRENCY = 'Symbol Currency',
  TAKE_PROFIT = 'Take Profit',
  TENANT_ID = 'Tenant Id',
  TRADER_SUBSCRIPTION = 'Trader Subscription',
  USER_ACCOUNT_TYPE = 'User account type',
  USER_GROUP = 'User Group',
  USER_ID = 'User Id',
  IS_SWITCH_ACCOUNT = 'Is Switch Account',
  EQUITY = 'Equity',
  CONTRACT_SIZE = 'Contract Size',
  PRICE = 'Price',
  TRADE_EXPIRY = 'Trade Expiry',
  EXPIRATION = 'Expiration (Server Time)',
  DISPLAY_TIME = 'Date & time of trading (Server Time)',
  MARGIN_LEVEL = 'Margin Level %',
  CLOSE_METHOD = 'Close Method',
  TOGGLE = 'Toggle',
  PAGE = 'Page',
  IS_FULL_CHART = 'Is Full Chart',
  DIRECTION = 'Direction',
  TRADE_PREFERENCE = 'Trade Preference',
  INITIAL_MARGIN = 'Initial Margin %',
  SWAP_LONG = 'Swap Long',
  SWAP_SHORT = 'Swap Short',
  MIN_STOP_DISTANCE = 'Min. Stop Distance',
  NUM_OF_POSITIONS_ALL = 'Number of Positions (All)',
  NUM_OF_POSITIONS_ACTUAL = 'Number of Positions (Actual)',
  BULK_CLOSE_TYPE = 'Bulk Close Type',
  COMMISSION = 'Commission',
  UNITS = 'Units',
  OPEN_TIME = 'Open Date (Server Time)',
  OPEN_PRICE = 'Open Price',
  CURRENT_PRICE = 'Current Price',
  PROFIT_LOSS = 'Profit/Loss',
  ENTRY_PRICE = 'Entry Price',
  SWAP = 'Swap',
  REALISE_PROFIT_LOSS = 'Realised Profit/Loss',
  MODAL_TYPE = 'Modal Type',
  WATCHLIST_TYPE = 'Watchlist Type',
  APPEARANCE_PREFERENCE = 'Appearance Preference',
  NEW_ACCOUNT_METATRADER_ID = "New Account's MetaTrader Id",
  POSITION_MODULE_TAB = 'Position Module Tab',
  FUNCTION = 'Function',
  INDICATORS_SELECTED = 'Indicators Selected',
  CHART_TYPE_SELECTED = 'Chart Type Selected',
  TIMEFRAME_SELECTED = 'Timeframe Selected',
  IS_ENABLED = 'IsEnabled',
  SETTING_SOURCE = 'Setting Source',
  DRAWING_TOOL_SELECTED = 'Drawing Tool Selected',
  ORDER_ID = 'Order Id',
  SLTP_TYPE = 'SLTP Type'
}

export enum EMixpanelEventNames {
  SCREEN_VIEW = 'Screen View',
  ACCOUNT_LOGIN = 'Account Login',
  ACCOUNT_SWITCHED = 'Account Switched',
  ACCOUNT_SWITCH_CLICKED = 'Account Switch Clicked',
  ACCOUNT_SWITCH_CONFIRM_CLICKED = 'Account Switch Confirm Clicked',
  ACCOUNT_SWITCH_CONFIRM_CANCEL_CLICKED = 'Account Switch Confirm (Cancel) Clicked',
  ACCOUNT_LOGOUT = 'Account Logout',
  ACCOUNT_LOGOUT_CLICKED = 'Account Logout Clicked',
  OCT_TOGGLE_CLICKED = 'OCT Toggle Clicked',
  OCT_AGREEMENT_CLICKED = 'OCT Agree and Continue Clicked',
  OCT_AGREEMENT_CANCEL = 'OCT Agree and Continue (Cancel) Clicked',
  TRADE_CLICKED = 'Trade Clicked',
  PLACE_TRADE_ORDER_CLICKED = 'Place Trade Order Clicked',
  OPW_MODAL_CANCEL_CLICKED = 'OPW Modal (Cancel) Clicked',
  TRADE_ORDER_CONFIRM_MODAL_CANCEL_CLICKED = 'Trade Order Confirmation Modal (Cancel) Clicked',
  TRADE_ORDER_SUBMITTED = 'Trade Order Submitted',
  CLOSE_ORDER_CLICKED = 'Close Order Clicked',
  CLOSE_ORDER_CONFRIM_CANCEL_CLICKED = 'Close Order Confirmation Modal (Cancel) Clicked',
  CLOSE_ORDER_SUBMITTED = 'Close Order Submitted',
  BULK_CLOSE_CLICKED = 'Bulk Close Clicked',
  BULK_CLOSE_POSITIONS_CLICKED = 'Bulk Close Positions Clicked',
  BULK_CLOSE_POSITIONS_SUBMITTED = 'Bulk Close Positions Submitted',
  BULK_CLOSE_CONFIRM_CANCEL_CLICKED = 'Bulk Close Positions Confirmation Modal (Cancel) Clicked',
  DELETE_ORDER_CLICKED = 'Delete Order Clicked',
  DELETE_PENDING_ORDER_SUBMITTIED = 'Delete Pending Order Submitted',
  DELETE_PENDING_ORDER_CONFIRM_CANCEL_CLICKED = 'Delete Pending Order Confirmation Modal (Cancel) Clicked',
  BULK_DELETE_CLICKED = 'Bulk Delete Clicked',
  BULK_DELETE_PENDING_ORDERS_SUBMITTED = 'Bulk Delete Pending Orders Submitted',
  BULK_DELETE_CONFIRM_CANCEL_CLICKED = 'Bulk Delete Confirmation Modal (Cancel) Clicked',
  BUY_BUTTON_CLICKED = 'Buy Button Clicked',
  SELL_BUTTON_CLICKED = 'Sell Button Clicked',
  ORDER_TYPE_CLICKED = 'Order Type Clicked',
  ORDER_TYPE_SELECTED = 'Order Type Selected',
  VOLUME_CLICKED = 'Volume Clicked',
  VOLUME_INCREASED = 'Volume Increased',
  VOLUME_DECREASED = 'Volume Decreased',
  FILL_POLICY_CLICKED = 'Fill Policy Clicked',
  FILL_POLICY_SELECTED = 'Fill Policy Selected',
  PRICE_FIELD_CLICKED = 'Price Field Clicked',
  PRICE_INCREASED = 'Price Increased',
  PRICE_DECREASED = 'Price Decreased',
  STOP_LIMIT_PRICE_FIELD_CLICKED = 'Stop Limit Price Field Clicked',
  STOP_LIMIT_PRICE_INCREASED = 'Stop Limit Price Increased',
  STOP_LIMIT_PRICE_DECREASED = 'Stop Limit Price Decreased',
  STOP_LOSS_PRICE_FIELD_CLICKED = 'Stop Loss Price Field Clicked',
  STOP_LOSS_PRICE_INCREASED = 'Stop Loss Price Increased',
  STOP_LOSS_PRICE_DECREASED = 'Stop Loss Price Decreased',
  STOP_LOSS_POINTS_FIELD_CLICKED = 'Stop Loss Points Field Clicked',
  STOP_LOSS_POINTS_INCREASED = 'Stop Loss Points Increased',
  STOP_LOSS_POINTS_DECREASED = 'Stop Loss Points Decreased',
  TAKE_PROFIT_PRICE_FIELD_CLICKED = 'Take Profit Price Field Clicked',
  TAKE_PROFIT_PRICE_INCREASED = 'Take Profit Price Increased',
  TAKE_PROFIT_PRICE_DECREASED = 'Take Profit Price Decreased',
  TAKE_PROFIT_POINTS_FIELD_CLICKED = 'Take Profit Points Field Clicked',
  TAKE_PROFIT_POINTS_INCREASED = 'Take Profit Points Increased',
  TAKE_PROFIT_POINTS_DECREASED = 'Take Profit Points Decreased',
  EXPIRY_CLICKED = 'Expiry Clicked',
  EXPIRY_SELECTED = 'Expiry Selected',
  EXPIRY_DATE_CLICKED = 'Expiry Date Clicked',
  EXPIRY_DATE_SELECTED = 'Expiry Date Selected',
  EXPIRY_TIME_CLICKED = 'Expiry Time Clicked',
  EXPIRY_TIME_SELECTED = 'Expiry Time Selected',
  ORDER_TYPE_CANCEL_CLICKED = 'Order Type Cancel Clicked',
  FILL_POLICY_CANCEL_CLICKED = 'Fill Policy Cancel Clicked',
  EXPIRY_CANCEL_CLICKED = 'Expiry Cancel Clicked',
  EXPIRY_DATE_CANCEL_CLICKED = 'Expiry Date Cancel Clicked',
  EXPIRY_TIME_CANCEL_CLICKED = 'Expiry Time Cancel Clicked',
  PAGE_CLICKED = 'Page Clicked',
  PAGE_FULL_CHART_CLICKED = 'Page (Full Chart) Clicked',
  PAGE_PORTRAIT_FULL_CHART_CLICKED = 'Page (Portrait Full Chart) Clicked',
  SETTINGS_CLICKED = 'Settings Clicked',
  ACCOUNT_BALANCE_DROP_DOWN_CLICKED = 'Account Balance Drop Down Clicked',
  ACCOUNT_BALANCE_TOOLTIP_CLICKED = 'Account Balance Tool-tip Clicked',
  SEARCH_CLICKED = 'Search Clicked',
  SYMBOL_SEARCHED_CLICKED = 'Symbol Searched Clicked',
  WATCHLIST_CLICKED = 'Watchlist Clicked',
  APPEARANCE_CLICKED = 'Appearance Clicked',
  APPEARANCE_PREFERENCE_CLICKED = 'Appearance Preference Clicked',
  VIEW_ACCOUNTS_CLICKED = 'View Accounts Clicked',
  LINK_ACCOUNT_CLICKED = 'Link Account Clicked',
  CONFIRM_LINK_ACCOUNT_CLICKED = 'Confirm Link Account Clicked',
  LINK_ACCOUNT_CONFIRMATION_MODAL_CANCEL_CLICKED = 'Link Account Confirmation Modal (Cancel) Clicked',
  SPECIFICATIONS_TAB_CLICKED = 'Specifications Tab Clicked',
  TRADE_TAB_CLICKED = 'Trade Tab Clicked',
  ONE_CLICK_TRADE_TAB_CLICKED = 'One Click Trade Tab Clicked',
  OPEN_POSITIONS_TAB_CLICKED = 'Open Positions Tab Clicked',
  PENDING_ORDERS_TAB_CLICKED = 'Pending Orders Tab Clicked',
  ORDER_HISTORY_TAB_CLICKED = 'Order History Tab Clicked',
  ORDER_HISTORY_ORDERS_DEALS_TAB_CLICKED = 'Order History (Orders & Deals) Tab Clicked',
  EDIT_ORDER_CLICKED = 'Edit Order Clicked',
  EDIT_ORDER_SUBMITTED = 'Edit Order Submitted',
  EDIT_ORDER_MODAL_CANCEL_CLICKED = 'Edit Order Modal (Cancel) Clicked',
  TRACK_ORDER_CLICKED = 'Track Order Clicked',
  INDICATORS_CLICKED = 'Indicators Clicked',
  INDICATORS_TOOL_TIP_CLICKED = 'Indicators Tool-tip Clicked',
  INDICATORS_SELECTED = 'Indicators Selected',
  CHART_TYPE_CLICKED = 'Chart Type Clicked',
  CHART_TYPE_SELECTED = 'Chart Type Selected',
  TIMEFRAME_DROPDOWN_CLICKED = 'Timeframe Dropdown Clicked',
  TIMEFRAME_SELECTED = 'Timeframe Selected',
  TIMEFRAME_MODAL_CANCEL_CLICKED = 'Timeframe Modal (Cancel) Clicked',
  DRAWING_TOOL_SELECTED = 'Drawing Tool Selected',
  TREND_LINE_DRAWN = 'Trend Line Drawn',
  DELETE_TREND_LINE_CLICKED = 'Delete Trend Line Clicked',
  HORIZONTAL_LINE_DRAWN = 'Horizontal Line Drawn',
  DELETE_HORIZONTAL_LINE_CLICKED = 'Delete Horizontal Line Clicked',
  VERTICAL_LINE_DRAWN = 'Vertical Line Drawn',
  DELETE_VERTICAL_LINE_CLICKED = 'Delete Vertical Line Clicked',
  CROSS_LINE_DRAWN = 'Cross Line Drawn',
  DELETE_CROSS_LINE_CLICKED = 'Delete Cross Line Clicked',
  CHART_SETTING_CLICKED = 'Chart Setting Clicked',
  CHART_RIGHT_CLICKED = 'Chart Right Clicked',
  REMOVE_ALL_DRAWINGS_CLICKED = 'Remove All Drawings Clicked',
  REMOVE_ALL_INDICATORS_CLICKED = 'Remove All Indicators Clicked',
  REMOVE_ALL_INDICATORS_DRAWINGS_CLICKED = 'Remove All Indicators Drawings Clicked',
  ASK_PRICE_ON_Y_AXIS_CLICKED = 'Ask Price on Y-Axis Clicked',
  CLEAR_ALL_TRACK_DETAILS_CLICKED = 'Clear All Track Details Clicked',
  RESET_CHART_CLICKED = 'Reset Chart Clicked',
  CHART_TRACKED_SET_CLICKED = 'Chart Tracked Set Clicked',
  CHART_TRACKED_REMOVED_CLICKED = 'Chart Tracked Removed Clicked',
  CHART_TRACKED_MODIFY_CLICKED = 'Chart Tracked Modify Clicked',
  CHART_COLOR_SETTING = 'Chart Color Setting',
  FEATURE_POPUP_TRY_IT_NOW_CLICKED = 'Feature Popup Try It Now Clicked',
  FEATURE_POPUP_GOT_IT_CLICKED = 'Feature Popup Got It Clicked',
  SIGNAL_EXPRESS_INTEREST = 'Signal Express Interest',
  SIGNAL_INTEREST_SUBMITTED = 'Signal Interest Submitted',
  PRICE_ALERTS_CLICKED = 'Price Alerts Clicked'
}

export enum EPage {
  TRADE = 'Trade',
  MARKETS = 'Markets',
  ASSETS = 'Assets',
  HOME = 'Home',
  SETTINGS = 'Settings',
  FULL_CHART = 'Full Chart',
  INFO = 'Info',
  NEWS = 'News',
  CALENDAR = 'Calendar',
  SIGNAL = 'Signal',
  COPY_TRADE = 'Copy Trade',
  DEALER = 'Dealer',
  EDUCATION = 'Education',
  MENU = 'Menu'
}

export enum EToggle {
  ON = 'On',
  OFF = 'Off'
}

export enum ETradePreference {
  ONE_CLICK_TRADING = 'One Click Trading',
  TWO_CLICK_TRADING = 'Two Click Trading'
}

export enum EBulkCloseType {
  ALL_POSITIONS = 'All Positions',
  PROFITABLE_POSITIONS = 'Profitable Positions',
  LOSING_POSITIONS = 'Losing Positions'
}

export enum EMixpanelModalType {
  OPW = 'OPW',
  EDIT_MODAL = 'EDIT_MODAL',
  CLOSE_ORDER_MODAL = 'CLOSE_ORDER_MODAL'
}

export enum EAdjustAction {
  VOLUME_INCREASED,
  VOLUME_DECREASED,
  PRICE_INCREASED,
  PRICE_DECREASED,
  STOP_LIMIT_PRICE_INCREASED,
  STOP_LIMIT_PRICE_DECREASED,
  STOP_LOSS_PRICE_INCREASED,
  STOP_LOSS_PRICE_DECREASED,
  STOP_LOSS_POINTS_INCREASED,
  STOP_LOSS_POINTS_DECREASED,
  TAKE_PROFIT_PRICE_INCREASED,
  TAKE_PROFIT_PRICE_DECREASED,
  TAKE_PROFIT_POINTS_INCREASED,
  TAKE_PROFIT_POINTS_DECREASED
}

export enum EOrderFieldAction {
  BUY_BUTTON_CLICKED,
  SELL_BUTTON_CLICKED,
  ORDER_TYPE_CLICKED,
  VOLUME_CLICKED,
  FILL_POLICY_CLICKED,
  PRICE_FIELD_CLICKED,
  STOP_LIMIT_PRICE_FIELD_CLICKED,
  STOP_LOSS_PRICE_FIELD_CLICKED,
  STOP_LOSS_PRICE_FIELD_INCREASED,
  STOP_LOSS_PRICE_FIELD_DECREASED,
  STOP_LOSS_POINTS_FIELD_CLICKED,
  STOP_LOSS_POINTS_FIELD_INCREASED,
  STOP_LOSS_POINTS_FIELD_DECREASED,
  TAKE_PROFIT_PRICE_FIELD_CLICKED,
  TAKE_PROFIT_POINTS_FIELD_CLICKED,
  EXPIRY_CLICKED,
  EXPIRY_DATE_CLICKED,
  EXPIRY_TIME_CLICKED
}

export enum EOrderFieldCancelAction {
  ORDER_TYPE_CANCEL_CLICKED,
  FILL_POLICY_CANCEL_CLICKED,
  EXPIRY_CANCEL_CLICKED,
  EXPIRY_DATE_CANCEL_CLICKED,
  EXPIRY_TIME_CANCEL_CLICKED
}

export enum EActionClick {
  PAGE_FULL_CHART_CLICKED,
  PAGE_PORTRAIT_FULL_CHART_CLICKED,
  SETTINGS_CLICKED,
  ACCOUNT_BALANCE_DROP_DOWN_CLICKED,
  ACCOUNT_BALANCE_TOOLTIP_CLICKED,
  SEARCH_CLICKED,
  SYMBOL_SEARCHED_CLICKED,
  WATCHLIST_CLICKED,
  APPEARANCE_CLICKED,
  APPEARANCE_PREFERENCE_CLICKED,
  VIEW_ACCOUNTS_CLICKED,
  LINK_ACCOUNT_CLICKED,
  CONFIRM_LINK_ACCOUNT_CLICKED,
  LINK_ACCOUNT_CONFIRMATION_MODAL_CANCEL_CLICKED,
  SPECIFICATIONS_TAB_CLICKED,
  ONE_CLICK_TRADE_TAB_CLICKED,
  TRADE_TAB_CLICKED,
  OPEN_POSITIONS_TAB_CLICKED,
  PENDING_ORDERS_TAB_CLICKED,
  ORDER_HISTORY_TAB_CLICKED,
  ORDER_HISTORY_ORDERS_DEALS_TAB_CLICKED,
  INDICATORS_CLICKED,
  INDICATORS_TOOL_TIP_CLICKED,
  INDICATORS_SELECTED,
  CHART_TYPE_CLICKED,
  CHART_TYPE_SELECTED,
  TIMEFRAME_DROPDOWN_CLICKED,
  TIMEFRAME_SELECTED,
  TIMEFRAME_MODAL_CANCEL_CLICKED,
  DRAWING_TOOL_SELECTED,
  TREND_LINE_DRAWN,
  DELETE_TREND_LINE_CLICKED,
  HORIZONTAL_LINE_DRAWN,
  DELETE_HORIZONTAL_LINE_CLICKED,
  VERTICAL_LINE_DRAWN,
  DELETE_VERTICAL_LINE_CLICKED,
  CROSS_LINE_DRAWN,
  DELETE_CROSS_LINE_CLICKED,
  CHART_SETTING_CLICKED,
  CHART_RIGHT_CLICKED,
  REMOVE_ALL_DRAWINGS_CLICKED,
  REMOVE_ALL_INDICATORS_CLICKED,
  REMOVE_ALL_INDICATORS_DRAWINGS_CLICKED,
  ASK_PRICE_ON_Y_AXIS_CLICKED,
  CLEAR_ALL_TRACK_DETAILS_CLICKED,
  RESET_CHART_CLICKED,
  EDIT_ORDER_MODAL_CANCEL_CLICKED
}

export enum EFeaturePopupAction {
  FEATURE_POPUP_TRY_IT_NOW_CLICKED,
  FEATURE_POPUP_GOT_IT_CLICKED
}

export enum EMixpanelChartSetting {
  REMOVE_ALL_DRAWINGS,
  REMOVE_ALL_INDICATORS,
  REMOVE_ALL_INDICATORS_DRAWINGS,
  ASK_PRICE_ON_Y_AXIS,
  CLEAR_ALL_TRACK_DETAILS,
  RESET_CHART,
  CHART_COLOR_SETTING,
  PRICE_ALERTS
}

export enum ESignalInterestAction {
  SIGNAL_EXPRESS_INTEREST,
  SIGNAL_INTEREST_SUBMITTED
}

export enum EMixpanelWatchlistFilter {
  POPULAR = 'Popular',
  TOP_LOSER = 'Top Loser',
  TOP_GAINER = 'Top Gainer',
  FAVOURITES = 'Favourites',
  TOP_PICK = 'Top Pick',
  ALL = 'All'
}

export enum EMixpanlThemeScheme {
  DARK = 'Dark',
  LIGHT = 'Light',
  SYSTEM = 'System'
}

export enum EMixpanelPositionModuleTab {
  OPEN_POSITIONS = 'Open Positions',
  PENDING_ORDERS = 'Pending Orders',
  ORDER_HISTORY = 'Order History'
}

export enum EMixpanelTrackFunction {
  TRACK = 'Track',
  UNTRACK = 'Untrack'
}

export enum EMixpanlChartSeries {
  CANDLESTICK = 'Candlestick',
  LINE = 'Line',
  LINE_BID = 'Line (Bid)',
  LINE_ASK = 'Line (Bid & Ask)'
}

export enum EMixpanelChartSettingSource {
  RIGHT_CLICK = 'Right Click',
  CHART_SETTINGS = 'Chart Settings'
}

export enum EMixpanelDrawingTool {
  TREND_LINE = 'trendLine',
  CROSS_LINE = 'crossLine',
  VERTICAL_LINE = 'verticalLine',
  HORIZONTAL_LINE = 'horizontalLine',
  HORIZONTAL_RAY_LINE = 'horizontalRayLine'
}

export enum EMixpanelSLTPType {
  SL = 'Stop Loss',
  TP = 'Take Profit',
  ENTRY = 'Entry Price',
  STOP_LIMIT = 'Stop Limit Price',
  TEMP_SL = 'Temporary Stop Loss',
  TEMP_TP = 'Temporary Take Profit'
}

export enum EMixpanelCloseMethod {
  CLOSE_ICON = 'Close-Icon',
  BACKDROP = 'Backdrop'
}
